import { render, staticRenderFns } from "./UserGroupsModal.vue?vue&type=template&id=555488e9&scoped=true&"
import script from "./UserGroupsModal.vue?vue&type=script&lang=js&"
export * from "./UserGroupsModal.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupsModal.vue?vue&type=style&index=0&id=555488e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555488e9",
  null
  
)

export default component.exports